<template>
    <div v-if="false == loading">
        <select :disabled="loading" class="form-control" ref="roomSelector" @change="selectChangeHandler($event)">
            <option value="0" selected="true">Filter by room:</option>
            <option v-for="room in rooms" :key="room.id" :value="room.id">{{ room.name }}</option>
        </select>
    </div>
</template>

<script>
import {callApi} from "@/shared/ApiHelper"
import {useApiStore} from "@/store/api.js"

export default {
    name: 'RoomFilter',

    data() {
        return {
            apiStore: useApiStore(),
            loading: true,
            rooms: [],
        }
    },

    methods: {
        selectChangeHandler(event) {
            this.$emit('filterChanged', event.target.value)
        },
    },

    props: {
        eventId: {
            type: Number,
            default: 0,
        },
    },

    async mounted() {
        try {
            const apiResponse = await callApi(this.apiStore.buildUrl('/events/rooms/?event=' + this.eventId))
            this.rooms = apiResponse.data
            this.loading = false
        } catch(x) {
            console.log(x)
        } finally {
            this.loading = false
        }
    },
}
</script>

<style scoped>
.form-control {
    margin-bottom: 0.8rem;
    width: 95% !important;
}
</style>